import { render, staticRenderFns } from "./hospitalequipment.vue?vue&type=template&id=0bb03ee7"
import script from "./hospitalequipment.vue?vue&type=script&lang=js"
export * from "./hospitalequipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports